import config from '../config';

import BackendAPI from '../api/BackendAPI';

export class AuthenticationService extends BackendAPI {
    constructor() {
        super();
        this.serverPath = config.coreApiUrl;
    }

    isLoggedIn() {
        const url = `${this.serverPath}v2/authcheck`;

        return this.request('GET', url).catch((err) => {
            if (err.message === 'unauthorized') {
                this.logout();
            }
        });
    }

    // todo: dev only remove this
    logout() {
        const url = `${this.serverPath}v2/logout`;

        return this.request('POST', url).then(() => {
            localStorage.removeItem('user');
            window.location.reload(true);
        });
    }

    // todo: dev only remove this
    login() {
        const url = `${this.serverPath}v2/login`;
        const piiHash = '51512ea09253ad7309446655ef1cb1eff525a5454f13c8391cc4ce540c4a0578e76d19e6896b023923d2abbff5bc6164643151c08d639fd05752f03c948aabb7e2a9a81f4864139a1d4f91a1985f3d78a542b73c2565db45874d092460e228db2415909c0ab381ba3ff106f74ccf48769be8ae48128bf10797587ff527e69386';

        return this.request('POST', url, { piiHash }).then((user) => {
            user.requiresMerge = true;
            localStorage.setItem('user', JSON.stringify(user));
        });
    }
}
